var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenContent7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "33.75px",
    height: "38.333px",
    viewBox: "0 0 33.75 38.333",
    enableBackground: "new 0 0 33.75 38.333",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.853,
    y: -0.567,
    transform: "matrix(0.7876 -0.6162 0.6162 0.7876 -8.2344 14.5616)",
    fill: "#F8A99F",
    width: 10.303,
    height: 39.583
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenContent7);
export default __webpack_public_path__ + "static/media/screen_content7.dca67daafc9012c23028b2a43be2e6b4.svg";
export { ForwardRef as ReactComponent };